import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { useEffect, useReducer } from "react";

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case "connection_error":
      return {
        isConnected: false,
        isConnecting: false,
        error: payload
      };

    case "connected":
      return {
        isConnected: true,
        isConnecting: false,
        error: null,
        connection: payload
      };

    case "reconnecting":
      return {
        isConnected: false,
        isConnecting: true,
        error: payload
      };

    case "disconnected":
      return {
        isConnected: false,
        isConnecting: false,
        error: payload
      };

    default:
      return state;
  }
};

var useChannel = function useChannel(url, accessToken) {
  var _useReducer = useReducer(reducer, {
    connection: null,
    isConnecting: true,
    isConnected: false,
    error: null
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  useEffect(function () {
    var connection, disposed;

    function connect() {
      return _connect.apply(this, arguments);
    }

    function _connect() {
      _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                connection = new HubConnectionBuilder().withUrl(url, {
                  accessTokenFactory: function accessTokenFactory() {
                    return accessToken;
                  }
                }).configureLogging(LogLevel.Information).withAutomaticReconnect().build();

                if (!disposed) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                connection.onreconnecting(function (error) {
                  if (!disposed) {
                    dispatch({
                      type: "reconnecting",
                      payload: error
                    });
                  }
                });

                if (!disposed) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                connection.onreconnected(function () {
                  if (!disposed) {
                    dispatch({
                      type: "connected",
                      payload: connection
                    });
                  }
                });

                if (!disposed) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                connection.onclose(function (error) {
                  if (!disposed) {
                    dispatch({
                      type: "disconnected",
                      payload: error
                    });
                  }
                });

                if (!disposed) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return");

              case 12:
                _context.prev = 12;
                _context.next = 15;
                return connection.start();

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](12);

                if (!disposed) {
                  dispatch({
                    type: "connection_error",
                    payload: _context.t0
                  });
                }

              case 20:
                if (!disposed) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("return");

              case 22:
                dispatch({
                  type: "connected",
                  payload: connection
                });

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[12, 17]]);
      }));
      return _connect.apply(this, arguments);
    }

    if (accessToken) {
      connect();
    }

    return function () {
      disposed = true;

      if (connection) {
        connection.stop();
      }
    };
  }, [accessToken, url]);
  return state;
};

export default useChannel;